import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Box, Spinner } from '@chakra-ui/react';

import { useAlert, useApi } from '@app/hooks';

import { EquipmentsGuideFormInstance } from './types';
import EditForm from './form';
import { Paper } from '../common/paper';

type EquipmentsGuideEditProps = {};

const EquipmentsGuideEdit: FC<EquipmentsGuideEditProps> = () => {
  const params = useParams<{ id: string }>();

  const api = useApi();
  const { success } = useAlert();

  const history = useHistory();

  const [instance, setInstance] = useState<
    EquipmentsGuideFormInstance | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      (async () => {
        const { data } = await api.equipments.getEquipmentModel(params.id);
        setInstance(data);
        setLoading(false);
      })();
    }
  }, [params.id]);

  const onFormSubmit = (instance: Partial<EquipmentsGuideFormInstance>) => {
    api.equipments.updateEquipmentsGuide({
        id: Number(params.id),
        description: instance.description || '',
        width: instance.width || 0,
        height: instance.height || 0,
        depth: instance.depth || 0,
        weight: instance.weight || 0,
        consumption_energy: instance.consumption_energy || 0,
        coolant: instance.coolant,
        is_use_lock: instance.is_use_lock,
        is_use_outdoor: instance.is_use_outdoor,
        is_adding_heater: instance.is_adding_heater,
        material_inner: instance.material_inner,
        volume_inner: instance.volume_inner,
        volume_on_floor: instance.volume_on_floor,
        shelves: instance.shelves || '0',
        comment: instance.comment || '',
        is_visible: instance.is_visible,
      }).then((response) => {

      success('Модель изменена');
      setInstance(undefined);
      history.push('/equipments-guide/');
    });
  };

  const onFormCancel = () => {
    history.goBack(); //push('/equipments-guide/');
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          {loading ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Spinner size='md' />
            </Box>
          ) : (
            <EditForm
              instance={instance}
              onSubmit={onFormSubmit}
              onCancel={onFormCancel}
              submitText="Изменить"
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default EquipmentsGuideEdit;
